import { router } from 'expo-router';

export const isRootLayoutNotMountedError = (error: unknown): boolean =>
  error instanceof Error &&
  error.message.includes(
    'Attempted to navigate before mounting the Root Layout',
  );

export const tryNavigateIgnoringUnmountedRoot = (
  navigate: () => void,
): boolean => {
  try {
    navigate();
    return true;
  } catch (error) {
    if (isRootLayoutNotMountedError(error)) {
      return false;
    }
    throw error;
  }
};

export const redirectToHomePage = () => {
  router.replace('/');
};

export const navigateBack = () => {
  if (router.canGoBack()) {
    router.back();
  } else {
    redirectToHomePage();
  }
};
